module.exports = __webpack_public_path__ + "img/Icon-feather-upload-cloud.9f8db3e1.svg";